import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AUTH_PREFIX_PATH, AUTHENTICATED_ENTRY, UNAUTHENTICATED_ENTRY } from 'configs/AppConfig';

const PublicRoute = () => {
	const { token, ...data } = useSelector((state) => state.auth);
	const userId = localStorage.getItem('user_id');


	return (token && userId) ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Outlet />;
	// return (token && userId) ? <Navigate to={AUTHENTICATED_ENTRY} /> : <Navigate to={`${AUTH_PREFIX_PATH}${UNAUTHENTICATED_ENTRY}`} replace />;
};

export default PublicRoute;
